export class RocheModalTrigger {
  public static trigger(id: string): void {
    window.dispatchEvent(new CustomEvent('rocheModalTrigger', { detail: id }));
  }

  public static close(): void {
    window.dispatchEvent(new CustomEvent('rocheModalClose'));
  }
}
